<div class="authincation h-100">
  <div class="container-fluid h-200">
    <div class="row h-100">
      <div class="col-lg-6 col-md-12 col-sm-12 mx-auto align-self-center">
        <div class="login-form">
          <div class="text-center">
            <h3 class="title">{{ 'auth.login' | translate }}</h3>
            <p>CoreAid Sağlık Hizmetleri Yönetim Portalı</p>
          </div>
          @if (!isVerificationForm) {
            <form [formGroup]="signInForm" (ngSubmit)="signIn()">
              <div class="mb-4">
                <label class="mb-1 text-dark">E-posta</label>
                <input type="email" formControlName="email" class="form-control" placeholder="E-Posta Adresi">
                <div *ngIf="signInForm.get('email')?.invalid && signInForm.get('email')?.touched" class="text-danger">
                  Lütfen E-posta adresinizi giriniz.
                </div>
              </div>
              <div class="mb-4 position-relative">
                <label class="mb-1 text-dark" for="">Parolanız</label>
                <input [type]="showPassword ? 'text' : 'password'" formControlName="password" class="form-control" placeholder="Parolanız">
                <span class="show-pass eye" (click)="togglePasswordVisibility()" role="button"  tabindex="-1">
                  <i class="fa" [ngClass]="showPassword ? 'fa-eye' : 'fa-eye-slash'"></i>
                </span>
                <div *ngIf="signInForm.get('password')?.invalid && signInForm.get('password')?.touched" class="text-danger">
                  Lütfen parolanızı giriniz.
                </div>
              </div>
              <div class="text-center mb-4">
                <button type="submit" [disabled]="signInForm.invalid" class="btn btn-primary btn-block">{{ 'auth.login' | translate }}</button>
              </div>
            </form>
            <div class="text-center">
              <a [routerLink]="['/auth/forgot-password/forgot-password']" class="btn-link text-primary">{{ 'auth.forgot-password' | translate }}</a>
            </div>
          }@else{
            <app-two-factor [verificationType]="verificationType"
              (goBackOn)="onGoBack()"
              (resendCodeOn)="signIn()"
              (sendCodeOn)="sendOtpCode($event)"
            ></app-two-factor>
          }
        </div>
      </div>
      <div class="col-xl-6 col-lg-6">
        <div class="pages-left h-100">
          <div class="login-content" style="
    height: 100%;
    margin: 0 auto;
    align-content: center;
">
            <img src="assets/theme/w3crm/images/acibadem-mobil-logo.png" class="acibadem-logo" alt="">
          </div>
         <!-- <div class="login-media text-center">
            <img src="/assets/theme/w3crm/images/ambulance-amico.png" alt="">
          </div>-->
        </div>
      </div>
    </div>
  </div>
</div>

<dialog class="module-selection-dialog" (cancel)="preventClose($event)" #moduleSelectionDialog>
  <div class="dialog-content text-center">
    <h3 class="title">{{ 'auth.module-select.title' | translate }}</h3>
    <p style="opacity: 0.8;">{{ 'auth.module-select.description' | translate }}</p>

    <div class="module-options">
      <button *ngFor="let module of availableModules | filterBy:'main':false " (click)="selectModule(module)" class="btn btn-primary btn-block">
        {{ module.name }}
      </button>
<ng-container *ngIf="(availableModules | filterBy:'main':true).length>0">
      <hr class="border-line">

      <button (click)="deleteModule()" class="btn btn-success btn-block p-3">
        Coreaid Yönetim Portalı'na Devam Et
      </button>
</ng-container>
    </div>
  </div>

</dialog>
